import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { 
            Dialog, 
            DialogContent, 
            DialogContentText, 
            Typography,
            Grid,
            Button,
            IconButton 
        } from '@material-ui/core';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
        textAlign : "center"
    },
    buttonSubmit: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
    },
    buttonRefresh: {
        color : 'white',
        backgroundColor : '#6878f2'
    },
    buttonCancel: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
    
    },
    dialogPaper: {
        height : '400px'
    },
    iconRefresh : {
        [theme.breakpoints.up('xs')]: {
            width: '45vw',
            height: '7vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('sm')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('lg')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('xl')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        
    },
    textQuestion : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        
    },
    textButtons : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid rgba(255, 198, 0)',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
        }
    },
}));

const validate = values => {
    const error  = {}
    if (!values.answer) {
        error.answer = "La respuesta es obligatoria"
    }
    if (/^(?!\s)/.test(values.answer) === false) {
        error.answer = "La respuesta no debe contener espacios en blanco al inicio."
    } 
    return error
}

const FormQuestionDialog = props => {

    const classes = useStyles();

    const {
        questionSelected, 
        openDialog,
        onCloseDialogQuestion,
        handleSubmit,
        handleRefreshQuestion,
        pristine
    } = props;

    return (
        <Dialog
            open={ openDialog }
            onClose={ onCloseDialogQuestion }
            fullWidth={true}
            maxWidth= 'lg'
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper : classes.dialogPaper}}
        >
            <DialogContent>

                <DialogContentText id="alert-dialog-description" align="center">
                    {'Conteste la siguiente pregunta de seguridad.' }
                </DialogContentText>

                <form className={classes.form} onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        
                        <Grid item xs={12} md={12} lg={12} xl={12} className = {classes.margin}>
                            <Typography component="h6" variant="h6" align = "center" className = {classes.textQuestion}>
                                {(questionSelected.question) ? questionSelected.question : ""}
                            </Typography>
                            <IconButton aria-label="delete"  onClick = {handleRefreshQuestion}>
                                <RefreshIcon className = {classes.iconRefresh}/>
                            </IconButton>
                        </Grid>
                        {/* <Grid item xs={12} md={12} lg={12} xl={12} className = {classes.margin}>
                            <IconButton aria-label="delete"  onClick = {handleRefreshQuestion}>
                                <RefreshIcon className = {classes.iconRefresh}/>
                            </IconButton>
                        </Grid> */}
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <Field
                                name="answer"
                                id="answer"
                                autoFocus = { true }
                                component={ RenderTextFieldRedux }
                                label="Respuesta"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6} lg={6} xl={6}>
                            <Button 
                                variant="contained" 
                                type="submit"
                                fullWidth
                                disabled={pristine }
                                className = {classes.submit}
                            >
                                { "Aceptar" }
                            </Button>
                        </Grid>
                        
                        <Grid item xs={6} md={6} lg={6} xl={6}>
                            <Button 
                                variant="contained" 
                                fullWidth
                                className = {classes.submit}
                                onClick = { onCloseDialogQuestion }
                                
                            >
                                Cancelar
                            </Button>   
                        </Grid>
                    </Grid>
                </form>

            </DialogContent>
        </Dialog>
    )

}

const FormQuestionDialogReduxForm = reduxForm(
    {
        form: 'FormQuestionDialog',
        validate
    }
)(FormQuestionDialog)
export default FormQuestionDialogReduxForm